module.exports = __webpack_public_path__ + "static/media/hero_map.76600e222f8ffebca5cd4a72d2ce7c23.png";